import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from './user/user.service';
import { ManagementEntityService } from './management-entity/management-entity.service';
import { CompanyService } from './company/company.service';
import { EntitySuperiorService } from './entity-superior/entity-superior.service';
import { BrokerService } from './broker/broker.service';
import { EmployeeService } from './employee/employee.service';
import { InsuredService } from './insured/insured.service';
import { DemandService } from './demand/demand.service';
import { ClasseService } from './classe/classe.service';
import { BrancheService } from './branche/branche.service';
import { ProductService } from './product/product.service';
import { ProfileService } from './profile/profile.service';
import { MarketLevelOrganizationService } from './market-level-organization/market-level-organization.service';
import { TrafficChiefService } from './traffic-chief/traffic-chief.service';
import { TrafficAgentService } from './traffic-agent/traffic-agent.service';
import { ExternalUserService } from './external-user/external-user.service';
import { CountryService } from './country/country.service';
import { RegionService } from './region/region.service';
import { ZoneService } from './zone/zone.service';
import { LocalityService } from './locality/locality.service';
import { TrafficControllerService } from './traffic-controller/traffic-controller.service';
import { MloAttestationGenerationConfigService } from './mlo-attestation-generation-config/mlo-attestation-generation-config.service';
import { VehicleUsageService } from './vehicle-usage/vehicle-usage.service';
import { IndemnityCustomTableService } from './indemnity-custom-table/indemnity-custom-table.service';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        UserService,
        ManagementEntityService,
        CompanyService,
        EntitySuperiorService,
        BrokerService,
        EmployeeService,
        InsuredService,
        DemandService,
        ClasseService,
        BrancheService,
        ProductService,
        ProfileService,
        MarketLevelOrganizationService,
        TrafficChiefService,
        TrafficAgentService,
        ExternalUserService,
        CountryService,
        RegionService,
        ZoneService,
        LocalityService,
        TrafficControllerService,
        MloAttestationGenerationConfigService,
        VehicleUsageService,
        IndemnityCustomTableService
    ]
})
export class ServicesModule { }